<template>
  <v-container id="page-approvement-detail">
    <div class="page-title">{{$route.name}}</div>
    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn class="mx-1" color="blue" outlined iconName="assignment" @click="onClickApprovement">결재하기</c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)" iconName="mdi-format-list-bulleted-square">
          돌아가기
        </c-btn>
      </v-col>
    </v-row>

    <!-- 결재타입 : 바우처 사용일 경우에만 주행 정보 표시-->
    <v-row v-if="this.aptypeConfig === 'aptype_voucher'">
      <v-col cols="12" md="12" sm="12">
        <c-card outlined class="mb-3">
          <div style="cursor: pointer" @click="$router.push(`/driveLog/${driveLogInfo.id}`)" class="page-title mb-3 font-weight-bold">주행 정보</div>
          <c-card outlined>
            <v-row align="center">
              <v-col cols="12" md="2" sm="6">
                <span>출발 시간</span>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <span
                    class="black--text">{{ this.driveLogInfo ? displayDatetime(this.driveLogInfo.startTime) : '-'  }}</span>
              </v-col>
              <v-col cols="12" md="2" sm="6">
                <span>도착 시간</span>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <span
                    class="black--text">{{  this.driveLogInfo ?  displayDatetime(this.driveLogInfo.endTime) : '-' }}</span>
              </v-col>
              <v-col cols="12" md="2" sm="6">
                <span>주행 시간</span>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <span class="black--text">{{ this.driveLogInfo ?  displayDuration(this.driveLogInfo.driveDuration) : '-' }}</span>
              </v-col>
              <v-col cols="12" md="2" sm="6">
                <span>대기 시간</span>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <span class="black--text">{{  this.driveLogInfo ?  displayDuration(this.driveLogInfo.waitDuration) : '-' }}<br>{{ this.waitLog.join(", ") }}</span>
              </v-col>
              <v-col cols="12" md="2" sm="6">
                <span>도움서비스 시간</span>
              </v-col>
              <v-col cols="12" md="4" sm="6">
                <span class="black--text">{{  this.driveLogInfo ?  displayDuration(this.driveLogInfo.serviceDuration) : '-' }}<br>{{ this.serviceLog.join(", ") }}</span>
              </v-col>
            </v-row>
          </c-card>
        </c-card>
      </v-col>
    </v-row>

    <c-card outlined class="mb-5" v-if="this.aptypeConfig === 'aptype_voucher' ||
      (this.aptypeConfig === 'aptype_gr_invite' || this.aptypeConfig === 'aptype_gr_join') && this.approveInfo.targetCustomerId">
      <div class="page-title mb-3 font-weight-bold"> 신청 회원 정보</div>
      <!--  v-if="this.aptypeConfig !== 'aptype_group' && this.aptypeConfig !== 'aptype_gr_invite' && this.aptypeConfig !== 'aptype_gr_join'"  -->
      <c-card outlined>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <span>이름</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <span style="cursor: pointer" @click="$router.push(`/customers/${approveInfo.customerId.id}`)" class="black--text common-name">{{ this.approveInfo.customerId ? $func.formatCustomerName(this.approveInfo.customerId) : '-' }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>생년월일</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span class="black--text">{{ this.approveInfo.customerId ? this.approveInfo.customerId.birth : '-' }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>성별</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span
              class="black--text">{{ this.approveInfo.customerId ? $func.gender(this.approveInfo.customerId.gender, true) : '-' }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>주소</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <div class="black--text">{{  this.approveInfo.customerId ? this.approveInfo.customerId.address : '-' }}</div>
            <div class="black--text">
              <span class="text--secondary"> (상세주소) </span>
              {{ this.approveInfo.customerId ? this.approveInfo.customerId.addressDetails : '-' }}</div>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>연락처</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span
                class="black--text">{{ this.approveInfo.customerId ? this.approveInfo.customerId.mobileNo : '-'}}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>소속 그룹</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <div v-for="item in joinedGroupList">
              <span style="cursor: pointer" @click="$router.push(`/group/${item.groupInfo.id}`)" class="black--text">{{ item.groupInfo.name }}</span>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>회원 유형</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <span class="black--text">{{ this.approveInfo.customerId ?  (this.approveInfo.customerId.customerType ? this.approveInfo.customerId.customerType.configName : '-') : '-' }}</span>
          </v-col>
        </v-row>
      </c-card>
    </c-card>  <!--  신청 회원 정보-->

    <c-card outlined class="mb-5" v-if="(this.aptypeConfig ==='aptype_member' || this.aptypeConfig === 'aptype_voucher_credential' || this.aptypeConfig === 'aptype_gr_join' || this.aptypeConfig === 'aptype_gr_req' || this.aptypeConfig === 'aptype_gr_invite')">
      <div class="page-title mb-3 font-weight-bold"> 가입 회원 정보</div>
      <c-card outlined>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <span>이름</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <span style="cursor: pointer" @click="$router.push(`/customers/${approveInfo.targetCustomerId.id}`)" class="black--text">{{ this.approveInfo.targetCustomerId.name }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>생년월일</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span class="black--text">{{  this.approveInfo.targetCustomerId.birth }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>성별</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span class="black--text">{{ $func.gender(this.approveInfo.targetCustomerId.gender, true) }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>주소</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <div class="black--text">{{  this.approveInfo.targetCustomerId.address }}</div>
            <div class="black--text">
              <span class="text--secondary"> (상세주소) </span>
              {{ this.approveInfo.targetCustomerId.addressDetails ? this.approveInfo.targetCustomerId.addressDetails : '-' }}</div>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>연락처</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span class="black--text">{{ this.approveInfo.targetCustomerId.mobileNo }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>소속 그룹</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <div v-for="item in joinedGroupList">
              <span style="cursor: pointer" @click="$router.push(`/group/${item.groupInfo.id}`)" class="black--text">{{ item.groupInfo.name }}</span>
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span>회원 유형</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <!--<span class="black&#45;&#45;text">{{ this.approveInfo.customerId ?  (this.approveInfo.customerId.customerType ? this.approveInfo.customerId.customerType.configName : '-') : '-' }}</span>-->
            <span class="black--text">{{  this.printCustomerType(this.aptypeConfig)   }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span v-if="this.approveInfo.targetCustomerId.customerType.configValue === 'ct_pregnant'">분만 예정일</span>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <span class="black--text">{{ this.approveInfo.targetCustomerId.customerType.configValue === 'ct_pregnant' ? this.approveInfo.targetCustomerId.expectedDeliveryDate : ''}}</span>
          </v-col>
        </v-row>
      </c-card>
    </c-card>  <!--  가입 회원 정보-->

    <!-- 그룹 회원 추가인 경우 그룹 정보 표시 -->
    <c-card outlined class="my-5"
            v-if="(this.aptypeConfig === 'aptype_gr_invite' || this.aptypeConfig === 'aptype_gr_join') && this.approveInfo.targetCustomerId">
      <div class="page-title font-weight-bold">신청 그룹</div>
      <group-info
          class="pl-0 pr-0"
          :groupDetailList="groupDetailList"
          :groupInfo="groupInfo"
      />
    </c-card>

    <c-card outlined>
      <div class="page-title mb-3 font-weight-bold">신청 정보</div>
      <c-card outlined>
        <v-row>
          <v-col cols="12" md="2" sm="6">
            <span>신청 일시</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span class="black--text"> {{ displayDatetime(this.approveInfo.created) }}</span>
          </v-col>
          <v-col cols="12" md="2" sm="6">
            <span>신청 유형</span>
          </v-col>
          <v-col cols="12" md="4" sm="6">
            <span class="black--text font-weight-bold"> {{ this.aptype }}</span>
          </v-col>

          <!-- 회원 유형 변경 || 바우처 자격증빙 시 -->
          <template
              v-if="this.aptypeConfig === 'aptype_member'||this.aptypeConfig === 'aptype_voucher_credential'">
            <v-col cols="12" md="2" sm="6">
              <span>변경 내용</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span class="black--text" v-if="this.aptypeConfig === 'aptype_member'||this.aptypeConfig === 'aptype_voucher_credential'"> {{((this.approveInfo.newCustomerType? this.approveInfo.newCustomerType.configName : '-') )}}</span>
            </v-col>
          </template>
          <!-- 바우처 사용 시 -->
          <template v-else-if="this.aptypeConfig === 'aptype_voucher'">
            <v-col cols="12" md="2" sm="6">
              <span>사용 바우처</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span style="cursor: pointer" @click="approveInfo.targetVoucherStateId ? $router.push(`/voucherUsage/${approveInfo.targetVoucherStateId.id}`) : ''"  class="black--text">{{ this.approveInfo.targetVoucherStateId ? this.approveInfo.targetVoucherStateId.voucherId.name : '-'  }}</span>
            </v-col>
            <v-col cols="12" md="2" sm="6">
              <span>소유자</span>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <span class="black--text">{{ this.approveInfo.targetCustomerId ? this.approveInfo.targetCustomerId.name : '-'  }}</span>
            </v-col>
          </template>
        </v-row>
      </c-card>

      <div class="page-title mt-8 mb-3 font-weight-bold">증빙 서류</div>
      <!-- documents image slider -->
      <c-card outlined
              max-width="500"
              class="mx-auto">
        <v-carousel
            height="600"
            hide-delimiter-background
        >
          <v-sheet
              v-if="apprDocumentList.length === 0"
              color="light2Grey"
              height="100%"
          >
            <v-row
                class="fill-height"
                align="center"
                justify="center"
            >
              <div>증빙서류가 존재하지 않습니다.</div>
            </v-row>
          </v-sheet>
          <v-carousel-item
              v-else
              v-for="item in apprDocumentList"
              :key="item.id"
              :src="$func.getImgUrl(item.photoUrl)"
              @click="openImageDialog(item)"
          ></v-carousel-item>
          <!--          <v-carousel-item-->
          <!--              v-for="n in 10"-->
          <!--              :key="n"-->
          <!--              :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"-->
          <!--              @click="openImageDialog(n)"-->
          <!--          ></v-carousel-item>-->
        </v-carousel>

        <!-- image dialog -->
        <v-dialog v-if="openImageFlag" v-model="openImageFlag" max-width="60%">
          <v-img :src="openImageSrc" :lazy-src="openImageSrc" style="background-color: white;"></v-img>
        </v-dialog>
      </c-card>

      <c-card outlined class="mt-3">
        <v-row>
          <v-col cols="12" md="2" sm="3">
            <span>메모</span>
          </v-col>
          <v-col cols="12" md="10" sm="9">
            <span class="black--text"> {{ this.approveInfo.userComment }}</span>
          </v-col>
        </v-row>
      </c-card>
    </c-card>

    <c-card outlined class="mt-5">
      <div class="page-title mb-3 font-weight-bold">승인 이력</div>
      <c-table :headers="tableHeader" :items="apprDetailList">
        <template #created="{item}">
          {{ displayDatetime(item.created) }}
        </template>
        <template #adminComment="{item}">
          <c-btn v-if="item.state === '반려' && item.adminComment" icon iconName="library_books" @click="openAdminCommentDialog(item.adminComment)"></c-btn>
        </template>
      </c-table>
    </c-card>

    <v-dialog v-model="adminCommentDialog" width="500" hide-overlay>
      <c-card class="white" title="반려 사유">
        {{ this.selectedAdminComment }}
      </c-card>
    </v-dialog>


    <!-- 결재하기 팝업 -->
    <v-dialog v-model="approveDialogFlag" width="500" persistent>
      <c-card class="white" title="결재하기">
        <v-row justify="start">
          <v-radio-group row dense v-model="approveState">
            <v-radio label="승인" value="approval"></v-radio>
            <v-radio label="반려" value="rejection"></v-radio>
          </v-radio-group>
        </v-row>

        <v-row>
          <!-- To Do : 바우처 발급해야할 때와 아닐 때를 구분지어서 조건을 수정해야함 -->
          <template
              v-if="approveState === 'approval' && this.showVoucherStateSetting">
            <v-row>
              <v-col cols="3">
                <span class="red--text mr-1">*</span><span>바우처 선택</span>
              </v-col>
              <v-col cols="9">
                <v-select
                    v-model="selectedVoucher"
                    :items="voucherList"
                    item-text="name"
                    item-value="id"
                    menu-props="{offsetY: true}"
                    hide-details
                    required
                    solo
                    :rules="[v => !!v]"
                    label="바우처를 선택해주세요"
                    @change="setDate"
                    return-object
                ></v-select>
              </v-col>
              <v-col cols="3">
                <span class="red--text mr-1">*</span><span>발급 개수</span>
              </v-col>
              <v-col cols="9">
                <div style="width: 130px; display: inline-block;">
                  <v-text-field v-model="voucherNum" solo hide-details required :rules="[v => !!v]" dense/>
                </div>
                <span class="ml-3">개</span>
              </v-col>
              <v-col cols="3">
                <span>{{this.approveInfo.newCustomerType.configValue === 'ct_baby' ? '생년월일' : '분만예정일'}}</span>
              </v-col>
              <v-col cols="9">
                <v-menu
                  v-model="dateSetMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div style="width: 200px; display: inline-block;">
                      <v-text-field
                        v-model="dateSet"
                        append-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker v-model="dateSet" @input="dateSetMenu = false" firstDayOfWeek="1" :selectedDate="dateSet" locale="ko-kr"/>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <span>사용 기한</span>
              </v-col>
              <v-col cols="9">
                <span class="red--text mr-1">*</span><span class="mr-5">지급일</span>
                <v-menu
                    v-model="payMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div style="width: 200px; display: inline-block;">
                      <v-text-field
                          v-model="payDate"
                          append-icon="event"
                          readonly
                          v-on="on"
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker v-model="payDate" @input="payMenu = false" firstDayOfWeek="1" :selectedDate="payDate" locale="ko-kr"/>
                </v-menu>
                <br/>
                <span class="red--text mr-1">*</span><span class="mr-5">만료일</span>
                <v-menu
                    v-model="expirationMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <div style="width: 200px; display: inline-block;">
                      <v-text-field
                          v-model="expirationDate"
                          append-icon="event"
                          readonly
                          v-on="on"
                      ></v-text-field>
                    </div>
                  </template>
                  <c-date-picker v-model="expirationDate" @input="expirationMenu = false" firstDayOfWeek="1"
                                 :selectedDate="expirationDate" locale="ko-kr"/>
                </v-menu>
              </v-col>
            </v-row>
            <div class="mx-auto">
              <span class="red--text">*</span> 바우처 발급 단계를 마무리 해야 결재가 승인 됩니다.<br/> 0개 입력 시 바우처 발급 없이 결재가 승인됩니다.
            </div>

          </template>
          <template v-else>
            <v-row v-if="this.aptypeConfig === 'aptype_gr_invite' || this.aptypeConfig === 'aptype_gr_join' || this.aptypeConfig === 'aptype_gr_req'"
                   class="font-weight-bold my-2" >
              <v-col cols="1" class="red--text">◈</v-col>
              <v-col cols="10">
                그룹 내의 회원과 <span class="red--text">바우처 공유</span>가 가능합니다.<br/>
                그룹 생성 및 가입을 위해 관련 증빙서류 제출과 관리자 승인이<br/> 필요할 수 있습니다.
              </v-col>
            </v-row>
            <v-textarea outlined label="반려 사유" v-model="rejectionValue" :disabled="approveState !== 'rejection'">
            </v-textarea>
          </template>
        </v-row>
        <v-row justify="center" class="mt-5">
          <c-btn outlined color="blue" class="mr-3" @click="approveApproval">확인</c-btn>
          <c-btn outlined color="grey" @click="cancelApprovement">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import GroupInfo from "../../Default/Common/GroupInfo";

  export default {
    components: {GroupInfo},
    data() {
      return {
        tableHeader: [
          {
            text: '담당자',
            value: 'admin',
            align: 'center',
            sortable: false,
          },
          {
            text: '처리 일시',
            value: 'created',
            align: 'center',
            sortable: true
          },
          {
            text: '진행 상황',
            value: 'state',
            align: 'center',
            sortable: false,
          },
          {
            text: '비고',
            value: 'adminComment',
            align: 'center',
            sortable: false,
          },
        ],
        approveInfo: [],
        apprDetailList: [],
        aptypeConfig: '',
        aptype: '',
        targetCustomerId: '',

        apprDocumentList: [],

        openImageFlag: false,
        openImageSrc: '',

        approveDialogFlag: false,
        approveState: 'approval',
        rejectionValue: '',

        voucherList: [],
        selectedVoucher: '',
        voucherNum: 10,

        payDate: this.$func.curDateString(),
        expirationDate: this.$moment().endOf('year').format('YYYY-MM-DD'),
        dateSet:'',
        payMenu: false,
        expirationMenu: false,
        dateSetMenu:false,

        customerActivationFlag: false,

        groupDetailList: [],
        groupInfo: [],

        joinedGroupList: [],
        driveLogInfo: null,

        waitLog: [],
        serviceLog: [],
        lastApprState : false,

        adminCommentDialog: false,
        selectedAdminComment: '',
        prevResult : null,
        isApprove: null,
        showVoucherStateSetting : false,
      }
    },
    mounted() {
      const {id} = this.$route.params;
      this.reqApprovementInfo(id);
      this.reqApprDetailList(id);
    },
    computed: {
      onApprBtnDisable(){
        return this.lastApprState;
      }
    },
    methods: {
      onClickApprovement() {
        this.approveDialogFlag = true;

        // 회원 유형 변경이거나 바우처 자격증빙 시
        if(this.aptypeConfig === 'aptype_member'|| this.aptypeConfig === 'aptype_voucher_credential') {
          this.showVoucherStateSetting = true;

          this.dateSet = this.approveInfo.newCustomerType.configValue === 'ct_baby' ? this.approveInfo.targetCustomerId.birth : this.approveInfo.targetCustomerId.expectedDeliveryDate;
        }
      },
      async reqApprovementInfo(id) {
        try {
          const res = await this.$api.getApprovementInfoById(id);
          this.approveInfo = res.data;
          this.aptypeConfig = this.approveInfo.approvementType.configValue;
          this.aptype = this.approveInfo.approvementType.configName;
          this.targetCustomerId = this.approveInfo.targetCustomerId.id;


          this.reqJoinedGroupDetailList(this.targetCustomerId);
          await this.reqApprDocumentList(this.approveInfo.customerId.id, this.approveInfo.id);
          this.distributeRoles();

          this.lastApprState = (res.data.approvementDetailId) ||  (res.data.approvementDetailId && res.data.approvementDetailId.state.configValue === '취소');
          const state = this.lastApprState?.state?.configValue
          this.prevResult = state === 'ap_approve' ? true : false;
          this.isApprove = state === 'ap_approve' ? 'approval' : state === 'ap_decline' ? 'rejection' : 'wait';
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqApprovementInfo'});
        }
      },
      async distributeRoles() {
        switch (this.aptypeConfig) {
          // 회원 유형 변경
          case 'aptype_voucher_credential' :
          case 'aptype_member' :
            await this.reqVoucherList();
            break;
          // 그룹 회원 가입
          case 'aptype_gr_invite'   :
          case 'aptype_gr_join' :
          case 'aptype_gr_req'  :
            if (this.approveInfo.targetGroupId) await this.reqGroupDetailList(this.approveInfo.targetGroupId.id);
            break;
          // 바우처 사용
          case 'aptype_voucher' :
            await this.reqDriveLog();
            break;
        }
      },
      displayDatetime(str) {
        return str ? this.$func.dateTimeToString(str): "-";
      },
      displayPeriod(str0, str1) {
        return this.$moment(str0).format("HH:mm:ss") + "~" + this.$moment(str1).format("HH:mm:ss");
      },
      displayDuration(sec) {
        let hours = Math.floor(sec / 3600);
        let minutes = Math.floor((sec - (hours * 3600)) / 60);
        let seconds = sec % 60;

        return hours + '시간 ' + minutes + '분 ' + seconds + '초';
      },
      openImageDialog(item) {
        this.openImageSrc = this.$func.getImgUrl(item.photoUrl);
        this.openImageFlag = true;
      },
      checkCustomerActivation(type) {
        if (type === -1) {
          this.reqVoucherAppr();
          return;
        }

        let customerName = this.approveInfo.targetCustomerId.name;
        let messages = (type === 1) ? `${customerName} 회원의 상태를 활성화 하시겠습니까?`
          : `${customerName} 회원의 상태를 비활성화 하시겠습니까? \n ${customerName} 회원의 기존 예약은 모두 취소됩니다.`;

        this.$store.commit('alert',
          {
            open: true, persistent: true,
            msg: messages,
            confirm: true, callBack: () => {
              this.reqVoucherAppr()
            }
          });
      },
      async reqDriveLog() {
        try {
          const res = await this.$api.getApprDriveLog(this.approveInfo.targetDriveLog2Id.id);
          this.driveLogInfo = res.data;

          this.waitLog = [];
          this.serviceLog = [];
          if (this.driveLogInfo && this.driveLogInfo.statusLog) {
            var statusLog = JSON.parse(this.driveLogInfo.statusLog);
            for (var i = 0; i < statusLog.length; i++) {
              var log = statusLog[i];
              if (log[0] == "ds_wait") {
                this.waitLog.push(this.displayPeriod(log[1], log[2]));
              } else if (log[0] == "ds_service") {
                this.serviceLog.push(this.displayPeriod(log[1], log[2]));
              }
            }
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqDriveLog'});
        }
      },
      async reqApprDocumentList(customerId, id) {
        try {
          const res = await this.$api.getApprDocumentList(customerId, id);

          this.apprDocumentList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqApprDocumentList'});
        }
      },
      async reqVoucherList() {
        try {
          const res = await this.$api.getVoucherListForApprovement();
          this.voucherList = res.data;
          const selectedVoucher = this.voucherList[0]
          this.selectedVoucher = selectedVoucher
          this.setDate(selectedVoucher)

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqVoucherList'});
        }
      },
      async reqApprDetailList(apprId) {
        try {
          const res = await this.$api.getApprDetailList(apprId);

          if(res.data.length < 1) {
            return;
          }
          this.apprDetailList = res.data.map((item, idx) => {
            item.admin = item.adminId ? item.adminId.name : '-';
            item.state = item.state.configName;
            // 상태값을 다른 곳에서 확인
            // if(idx === 0) {
            //   this.prevResult = item.state === '승인' ? true : false;
            //   this.isApprove = item.state === '승인' ? 'approval' : item.state === '반려' ? 'rejection' : 'wait';
            // }
            return item;
          });

          // this.lastApprState = (res.data[0].state && res.data[0].state === '승인') || (res.data[0].state && res.data[0].state === '취소');
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqApprDetailList'});
        }
      },
      async reqGroupDetailList(groupId) {
        try {
          const res = await this.$api.getGroupDetailList(groupId);

          this.groupDetailList = res.data;
          if (this.groupDetailList.length > 0) this.groupInfo.push(this.groupDetailList[0].groupInfo);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGroupDetailList'});
        }
      },
      async reqJoinedGroupDetailList(customerId) {
        try {
          const res = await this.$api.getJoinedGroupDetailList(customerId);

          this.joinedGroupList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqJoinedGroupDetailList'});
        }
      },
      cancelApprovement() {
        this.approveDialogFlag = false;
        this.showVoucherStateSetting = false;
        this.selectedVoucher = this.voucherList[0]
        this.voucherNum = 10
        this.setDate(this.selectedVoucher)
      },
      async approveApproval() {
        //voucherNum의 type은 string으로, !== 대신 != 으로 처리
        //회원유형변경 중 승인일 경우 중에서 voucherNum이 0개 이상인데 바우처를 선택하지 않았거나, voucherNum에 아무것도 들어있지 않은 경우에만
        if(this.approveState === 'approval' && this.showVoucherStateSetting && (!this.voucherNum || (!this.selectedVoucher && this.voucherNum != 0))) {
          this.$store.commit('snackbar', {timeout : 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }

        if (this.approveInfo.targetCustomerId.state === 'Disable') {
          this.$store.commit('snackbar', {timeout: 2000, msg: '삭제된 회원이므로 결재가 불가능합니다.'});
          this.approveDialogFlag = false;
          return;
        }
        /* 승인 => 승인, 반려 => 반려 의 경우 block */
        if (this.isApprove === this.approveState) {
          const approveMsg = this.isApprove === 'approval' ? '승인' : '반려';
          this.$store.commit('snackbar', {timeout: 2000, msg: `이미 ${approveMsg}된 결재입니다.`});
          this.approveDialogFlag = false;
          return;
        }
        this.approveDialogFlag = false;

        switch (this.aptypeConfig) {
          // 회원 유형 변경
          case 'aptype_voucher_credential' :
          case 'aptype_member' :
            if (this.approveState === 'approval' && !this.selectedVoucher && this.voucherNum != 0) {
              this.$store.commit('snackbar', {timeout: 2000, msg: '바우처를 선택해주세요.'});
              return;
            } else {
              const date = this.dateSet;
              await this.reqCustomerTypeAppr();
              if(this.approveState === 'approval') {
                if((this.approveInfo.newCustomerType.configValue === 'ct_baby' && this.approveInfo.targetCustomerId.birth !== date) ||
                  (this.approveInfo.newCustomerType.configValue === 'ct_pregnant' && this.approveInfo.targetCustomerId.expectedDeliveryDate !== date) )
                  this.updateCustomerInfo(date);
              }
            }
            break;
          // 그룹 회원 가입
          case 'aptype_gr_invite'   :
          case 'aptype_gr_join' :
          case 'aptype_gr_req'  :
            await this.reqGroupAppr();
            break;
          // 바우처 사용
          case 'aptype_voucher' :
            // 만료일이 과거시간 일 때
            // if (this.$moment(this.approveInfo.targetVoucherStateId.expirationDate).isBefore(this.$moment())) {
            //   this.$store.commit('snackbar', {timeout: 2000, msg: '바우처 만료일이 과거 시간 입니다.'});
            //   this.approveDialogFlag = false;
            //   return;
            // }

            let type = -1;
            // type 1 : 비활성화 상태의 회원을 승인할 경우
            if (this.approveState === 'approval' && this.approveInfo.targetCustomerId.active === 'Disable') type = 1;
            // type 2 : 활성화 상태의 회원을 반려할 경우
            else if (this.approveState === 'rejection' && this.approveInfo.targetCustomerId.active === 'Enable') type = 2;
            await this.checkCustomerActivation(type);
            break;
        }
      },
      async reqVoucherAppr() {
        try {
          let reqData = {
            adminComment: this.rejectionValue,
            result: this.approveState === 'approval',
            targetCustomerId: this.approveInfo.targetCustomerId.id,
            apprId: this.approveInfo.id,
            prevResult : this.prevResult
          };

          const res = await this.$api.voucherAppr(reqData);

          let msg = this.approveState === 'approval' ? '승인' : '반려';
          this.successApproval(msg);
          this.reqApprDetailList(this.approveInfo.id);
          this.approveDialogFlag = false;
        } catch (err) {
          this.reqApprDetailList(this.approveInfo.id);
          this.$store.commit('snackbar', {err, where: 'reqVoucherAppr'});
        } finally {
          this.clearForm();
        }
      },
      successApproval(msg) {
        this.$store.commit('alert', {open: true, timeout: 3000, msg: msg + " 되었습니다."});
      },
      async reqGroupAppr() {
        try {
          let reqData = {
            adminComment: this.rejectionValue,
            result: this.approveState === 'approval',
            customerId: this.approveInfo.customerId.id,
            targetCustomerId: this.approveInfo.targetCustomerId.id,
            targetGroupInfoId: this.approveInfo.targetGroupId.id,
            apprId: this.approveInfo.id,
            prevResult : this.prevResult,
          };

          const res = await this.$api.groupAppr(reqData);

          let msg = this.approveState === 'approval' ? '승인' : '반려';
          this.successApproval(msg);
          this.reqApprDetailList(this.approveInfo.id);
          this.approveDialogFlag = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGroupAppr'});
        } finally {
          this.clearForm();
        }
      },
      async reqCustomerTypeAppr() {
        try {
          let approvalResult = (this.approveState === 'approval');
          let reqData = {
            issueDate: approvalResult ? this.payDate : '',
            expirationDate: approvalResult ? this.expirationDate : '',
            issueCnt: approvalResult ? this.voucherNum : '',
            adminComment: this.rejectionValue,
            result: this.approveState === 'approval',
            approvementId: this.approveInfo.id,
            targetCustomerId: this.approveInfo.targetCustomerId.id,
            voucherId: approvalResult ? this.selectedVoucher.id : '',
            prevResult : this.prevResult
          };
          const res = await this.$api.customerTypeAppr(reqData);

          let msg = this.approveState === 'approval' ? '승인' : '반려';
          this.successApproval(msg);
          this.reqApprDetailList(this.approveInfo.id);
          this.approveDialogFlag = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqCustomerTypeAppr'});
        } finally {
          this.clearForm();
        }
      },
      openAdminCommentDialog(item) {
        this.adminCommentDialog = true;
        this.selectedAdminComment = item;
      },
      clearForm() {
        this.approveState = 'approval';
        this.rejectionValue = '';
        this.selectedVoucher = '';
        this.voucherNum = 10;
        this.payDate = this.$func.curDateString();
        this.expirationDate = this.$moment().endOf('year').format('YYYY-MM-DD');
        this.dateSet ='';
        this.payMenu = false;
        this.expirationMenu = false;
        this.dateSetMenu = false;

      },
      printCustomerType(inputAptype) {
        if(inputAptype ==='aptype_member'||inputAptype ==='aptype_voucher_credential') {
          return this.approveInfo.targetCustomerId.customerType ? (this.approveInfo.newCustomerType? this.approveInfo.newCustomerType.configName : '-') : '-';
        } else {
          return this.approveInfo.targetCustomerId.customerType ? this.approveInfo.targetCustomerId.customerType.configName : '-';
        }
      },
      async updateCustomerInfo(date) {
        const customerInfo = this.approveInfo.targetCustomerId;
        const reqParam = {
          id: customerInfo.id,
          customerTypeString : this.approveInfo.newCustomerType.configValue,
          date : date,
        };
        await this.$api.updateCustomerExpectedDate(reqParam);
        this.reqApprovementInfo(this.$route.params.id);
      },
      setDate(data) {
        this.payDate = this.$moment(data.effectiveDate).format('YYYY-MM-DD');
        this.expirationDate = this.$moment(data.expirationDate).format('YYYY-MM-DD');
      }
    }
  }
</script>

<style scoped>

</style>
